import BtnIcon from '@/components/button/BtnIcon'
import MatchingshipThemeRow from '@/components/card/MatchingshipThemeRow'
import TimeSupport from '@/utils/time-support'

export default {
  components: {
    BtnIcon,
    MatchingshipThemeRow
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    endAt () {
      return this.value.end_at.humanWithSuffix(this.$t('text.endAtSuffix'))
    },
  },
  methods: {
    onAnswer (matchingship) {
      this.$emit('on-answer', matchingship)
    },
    onResult (matchingship) {
      this.$emit('on-result', matchingship)
    },
    onMatchingResult (matching) {
      this.$emit('on-matchingResult', matching)
    }
  },
}
